import styled from '@emotion/styled';
import * as React from 'react';
import { PageWidget } from '../../widgets/layout/PageWidget';
import { ComparisonTable } from './ComparisonTable';
import { PricingPlans } from './pricingPlans';
import { CustomPricingTile, PricingTile } from './PricingTile';
import { StartBuildingLink } from '../../widgets/layout/header/SharedButtons';
import { SectionWidget } from '../../widgets/layout/SectionWidget';
import { Link } from 'react-router';
import { SiteRoute } from '@journeyapps/package-types';

const oxide = require('../../../media/stack/oxide.png');

export const PricingPage: React.FC = () => {
  return (
    <PageWidget title="Pricing" width={1120}>
      <S.Container>
        <S.Intro>
          <h1>Plans and pricing</h1>
          <p>Start with the essentials, then add collaboration, integrations and controls as your needs grow.</p>
          <S.FeatureLink to={SiteRoute.FEATURES}>
            Browse features and plan availability <span aria-hidden="true">→</span>
          </S.FeatureLink>
        </S.Intro>
        <S.TileContainer>
          {PricingPlans.map((p, i) => (
            <PricingTile key={i} plan={p} planIndex={i} />
          ))}
          <CustomPricingTile />
        </S.TileContainer>
        <S.ComparisonHeading id="plan-comparison">
          <h2>Compare plans</h2>
          <p>Review capacity, platform capabilities and support side by side.</p>
        </S.ComparisonHeading>
        <S.Comparison plans={PricingPlans} />
        <SectionWidget
          image={oxide}
          label="Get started with a free trial"
          content={
            <>
              <p>
                You can get started today with a free trial. This will take you right into OXIDE where you can follow an
                interactive tutorial that only takes a few minutes to complete.
              </p>
              <StartBuildingLink />
            </>
          }
          index={1}
        />
      </S.Container>
    </PageWidget>
  );
};

namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
  `;

  export const Intro = styled.header`
    max-width: 760px;
    margin: 0 auto 8px;
    text-align: center;

    h1 {
      margin: 0 0 12px;
      color: ${(p) => p.theme.text.heading};
      font-family: 'Inter Tight Variable', sans-serif;
      font-size: clamp(34px, 4vw, 42px);
      line-height: 1.12;
    }

    p {
      margin: 0 auto 18px;
      max-width: 600px;
      color: ${(p) => p.theme.text.paragraph};
      font-size: 17px;
      line-height: 1.65;
    }
  `;

  export const FeatureLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: ${(p) => p.theme.text.special};
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  `;

  export const ComparisonHeading = styled.div`
    margin-top: 16px;
    text-align: center;

    h2 {
      margin: 0 0 8px;
      color: ${(p) => p.theme.text.heading};
      font-size: 28px;
    }

    p {
      margin: 0;
      color: ${(p) => p.theme.text.paragraph};
    }
  `;

  export const TileContainer = styled.div`
    display: flex;
    gap: 18px;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
  `;

  export const Comparison = styled(ComparisonTable)`
    margin-top: 0;
  `;
}
